









































































import { Component, Vue, Watch } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import Toast from '@/components/display/toast.vue';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

@Component({
	components: {
		secondaryNav,
		Toast,
		VueCtkDateTimePicker,
	},
})
export default class ExportsView extends Vue {
	public loading = true;

	// public url = process.env.VUE_APP_API_URL + '/transceivers/export/get';
	public url = process.env.VUE_APP_API_URL + '/exports/get/';

	public type = 'transceivers';

	public exportTypes = [
		{ text: 'products', label: 'All Products' },
		{ text: 'payments', label: 'Payments' },
		{ text: 'sites', label: 'All Sites' },
		{ text: 'kpi', label: 'KPI Report' },
		{ text: 'orgs', label: 'All Orgs' },
		{ text: 'users', label: 'All Users' },
	];

	public entityTypes = [
		{ text: '-- Select one --', value: null },
		{ text: 'Fuel Tanks', value: 'fuelTanks' },
		{ text: 'Gateways', value: 'gateways' },
		{ text: 'Nodes', value: 'nodes' },
		{ text: 'Sensors', value: 'sensors' },
		{ text: 'Transceivers', value: 'transceivers' },
		{ text: 'Vats', value: 'vats' },
		{ text: 'Water Entities', value: 'water' },
		{ text: 'Feed Tanks', value: 'feedTanks' },
	];

	public selectedEntityType = null;

	public partnerBillingTypes = [
		{ text: '-- Select one --', value: null },
		{ text: 'Milk Partner Billing', value: 'milkPartnerBilling' },
		{ text: 'Fuel Partner Billing', value: 'fuelPartnerBilling' },
		{ text: 'Feed Partner Billing', value: 'feedPartnerBilling' },
	];

	public selectedPartnerBillingType = null;

	public form = {
		start: moment()
			.subtract(30, 'days')
			.locale('en-nz')
			.format('YYYY-MM-DD'),
		end: moment()
			.locale('en-nz')
			.format('YYYY-MM-DD'),
	};

	constructor() {
		super();
	}

	public forceFileDownload(response) {
		const url = window.URL.createObjectURL(new Blob([response.data]));
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', this.type + '.csv');
		document.body.appendChild(link);
		link.click();
	}

	public download(type: string) {
		this.type = type;
		// exports/get/notifications?startDate=2021-04-01&endDate=2021-04-03
		// exports/get/transceivers
		this.$http({
			method: 'get',
			url:
				this.type === 'notifications'
					? `${this.url}${this.type}?startDate=${this.form.start}&endDate=${this.form.end}`
					: `${this.url}${this.type}`,
			responseType: 'arraybuffer',
		})
			.then(response => {
				this.forceFileDownload(response);
			})
			.catch(() => console.log('error occured'));
	}

	public downloadFromDropdown(type: string, label: string) {
		if (type == null) {
			alert(`Select an option from ${label} dropdown`);
		} else {
			this.download(type);
		}
	}

	public async load() {
		this.loading = false;
	}

	public created() {
		this.load();
	}
}
